function hokuroName() {
  const name = [
    '　',
    'サーモン',
    '12指腸',
    '12指腸',
    '12指腸',
    'サーモン',
    'ぬべ',
    'スミス',
    'サーモン',
    '不知火エンキ',
    'バルフレア',
    'マグロ',
    '西蓮寺',
    '12指腸',
    '組込式鯵フライ',
    'しゃふの植杉',
    '12指腸',
    'ぬべ',
    'サーモン',
    'サーモン',
    'サーモン',
    'サーモン',
    'サーモン',
    '12指腸',
    '12指腸',
    '12指腸',
    '12指腸',
    '12指腸',
  ]
  return name
}
export default hokuroName
